import React, { useEffect } from "react";
import { Select } from "antd";
import GetSubMerchants from "functions/admin/getSubMerchants";

const { Option } = Select;

const SubMerchantSelect = ({
  onChange,
  value,
  size = "medium",
  merchantId,
  autoSelectFirst = false,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line
  }, []);

  const fetchList = async () => {
    setLoading(true);
    const response = await GetSubMerchants(merchantId);
    setLoading(false);
    if (!response) return;

    const merchants = response.data.map((e) => ({ id: e.id, name: e.name }));
    if (autoSelectFirst) {
      setData(merchants);
      if (!value && merchants.length > 0 && onChange) {
        onChange(merchants[0].id);
      }
    } else {
      setData([{ id: null, name: "сонго" }, ...merchants]);
      if (!value && onChange) onChange(null);
    }
  };

  return (
    <Select
      placeholder="Select a merchant"
      onChange={onChange}
      value={value}
      loading={loading}
      size={size}
      style={{ width: "100%" }}
    >
      {data.map((item) => (
        <Option key={item.id ?? "none"} value={item.id}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default SubMerchantSelect;
